/*
 * Copyright (c) 2025. Bolmate B.V.
 */

import React, {useContext} from 'react';
import {AppContext} from "../misc/appContext";
import {SubscriptionModuleName} from "../../util/enums";

export default function PremiumNotificationLabel() {
    const {user} = useContext(AppContext).userContext;
    const module = user?.subscription?.getModule(SubscriptionModuleName.NOTIFICATIONS);
    const isTrialing = module?.isTrialing();
    return (
        <div className='premium-notification-label-container'>
            <label className='premium-notification-label'>Premium</label>
            <p className='premium-notification-info'>
                Deze notificatie is een premium notificatie en is beschikbaar via de Notificaties module.
                {isTrialing && (
                    <>
                        <br/>
                        Gratis te gebruiken gedurende jouw proefperiode.
                    </>
                )}
            </p>
        </div>
    )
}
